/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerGetConversationHistoryQueryResponse, AiAgentV2ControllerGetConversationHistoryPathParams, AiAgentV2ControllerGetConversationHistoryQueryParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerGetConversationHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { aiAgentV2ControllerGetConversationHistory } from "../../clients/ai-agent-v2Service/aiAgentV2ControllerGetConversationHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const aiAgentV2ControllerGetConversationHistoryQueryKey = (threadId: AiAgentV2ControllerGetConversationHistoryPathParams["threadId"], params: AiAgentV2ControllerGetConversationHistoryQueryParams = {}) => [{
  url: '/api/v1/ai-agent-v2/history/:threadId',
  params: {
    threadId: threadId
  }
}, ...(params ? [params] : [])] as const;
export type AiAgentV2ControllerGetConversationHistoryQueryKey = ReturnType<typeof aiAgentV2ControllerGetConversationHistoryQueryKey>;
export function aiAgentV2ControllerGetConversationHistoryQueryOptions(threadId: AiAgentV2ControllerGetConversationHistoryPathParams["threadId"], params?: AiAgentV2ControllerGetConversationHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = aiAgentV2ControllerGetConversationHistoryQueryKey(threadId, params);
  return queryOptions<AiAgentV2ControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<Error>, AiAgentV2ControllerGetConversationHistoryQueryResponse, typeof queryKey>({
    enabled: !!threadId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return aiAgentV2ControllerGetConversationHistory(threadId, params, config);
    }
  });
}

/**
 * @description Returns conversation history grouped by question-answer pairs
 * @summary Get conversation history for a thread
 * {@link /api/v1/ai-agent-v2/history/:threadId}
 */
export function useAiAgentV2ControllerGetConversationHistory<TData = AiAgentV2ControllerGetConversationHistoryQueryResponse, TQueryData = AiAgentV2ControllerGetConversationHistoryQueryResponse, TQueryKey extends QueryKey = AiAgentV2ControllerGetConversationHistoryQueryKey>(threadId: AiAgentV2ControllerGetConversationHistoryPathParams["threadId"], params?: AiAgentV2ControllerGetConversationHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<AiAgentV2ControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? aiAgentV2ControllerGetConversationHistoryQueryKey(threadId, params);
  const query = useQuery({
    ...aiAgentV2ControllerGetConversationHistoryQueryOptions(threadId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}